<template>
  <div class="card card-custom bgi-no-repeat card-stretch gutter-b">
    <div class="card-header border-0">
      <h3 class="card-title text-dark">پخش‌ها</h3>
      <div class="card-toolbar">
        <button
          v-if="activeLives.length"
          type="button"
          class="btn btn-sm btn-danger mr-1"
          ref="stop_live_btn"
          @click="stop()"
        >
          <i class="fas fa-stop"></i>توقف
        </button>

        <div v-if="activeLives.length > 1" class="btn-group" role="group">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            title="جلو"
            @click="forward()"
          >
            <i class="fal fa-arrow-right p-0" />
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            title="عقب"
            @click="back()"
          >
            <i class="fal fa-arrow-left p-0" />
          </button>
        </div>
      </div>
    </div>
    <div class="card-body pt-2 pb-4">
      <div class="row">
        <div class="col-md-12">
          <PlayerComp
            v-if="activeLives.length && currentLive"
            :live="currentLive.program"
          ></PlayerComp>
        </div>
      </div>
      <div v-if="activeLives.length === 0">پخش فعالی یافت نشد .</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_ACTIVE_LIVES,
  STOP_LIVE
} from "@/core/services/store/lives.module";
// import HlsPlayer from "@/view/content/widgets/HlsPlayer";
import Swal from "sweetalert2";
import PlayerComp from "@/view/pages/programs/comp/PlayerComp.vue";

export default {
  name: "count-info",
  components: {
    PlayerComp
  },
  data() {
    return {
      activeSlide: 0,
      playerSrc: null,
      liveInterval: null
    };
  },
  mounted() {
    this.getLives();
    this.liveInterval = setInterval(() => {
      this.getLives();
    }, 10000);
  },
  beforeDestroy: function() {
    clearInterval(this.liveInterval);
    this.liveInterval = null;
  },
  computed: {
    ...mapGetters(["activeLives"]),
    currentLive() {
      return this.activeLives[this.activeSlide];
    }
  },
  methods: {
    getLives() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_ACTIVE_LIVES)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    forward() {
      if (this.activeSlide < this.activeLives.length - 1) {
        this.activeSlide++;
      } else {
        this.activeSlide = 0;
      }
    },
    back() {
      if (this.activeSlide === 0) {
        this.activeSlide = this.activeLives.length - 1;
      } else {
        this.activeSlide--;
      }
    },
    stop() {
      Swal.fire({
        title: "",
        text: "آیا از توقف برنامه‌ اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          let stopBtn = this.$refs["stop_live_btn"];
          this.disableBtn(stopBtn);

          this.$store
            .dispatch(STOP_LIVE, this.currentLive.id)
            .then(() => {
              this.getLives();
              this.enableBtn(stopBtn);
              this.forward();
            })
            .catch(() => {
              this.enableBtn(stopBtn);
            });
        }
      });
    }
  }
};
</script>
